import { Link, useNavigate } from "react-router-dom";
import { ReferenceHeader } from './ReferenceHeader';
import '../reference.css';
import { HardwireLogo } from "./HardwireMark";
import { Phone, Mail, ArrowUpRight } from "lucide-react";
import { BUSINESS, PUBLIC_NAV } from "../lib/business";
import { OfficeAddress } from "./OfficeAddress";

export function PublicShell({ children, wide = false, home = false }) {
  const navigate = useNavigate();
  return (
    <div className="public-site min-h-screen bg-white text-slate-900">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:block focus:p-3" data-testid="skip-content">Skip to content</a>
      <ReferenceHeader />
      <main id="main-content" className={home ? '' : `mx-auto ${wide ? 'max-w-6xl' : 'max-w-3xl'} px-5 py-12 lg:py-16`}>{children}</main>
      <footer id="site-footer" className="bg-[#0B1120] pt-14 text-slate-300">
        <div className="mx-auto grid max-w-[1400px] gap-9 px-5 pb-12 sm:grid-cols-2 lg:grid-cols-4 lg:px-8">
          <div>
            <HardwireLogo size={120} variant="full" tone="dark" testId="footer-supplied-logo" />
            <p className="mt-4 text-sm leading-relaxed text-slate-400">Electrical service for homes, businesses, and builders. Based in Ocala, Florida.</p>
            <Link to="/quote" className="mt-5 inline-flex items-center gap-2 font-semibold text-[#F7C52B]" data-testid="footer-quote-link">Start your project <ArrowUpRight size={16} /></Link>
          </div>
          <div>
            <h2 className="mb-4 text-base font-bold text-white">Commercial Office</h2>
            <OfficeAddress testId="footer-office-address" />
            <p className="mt-3 text-xs leading-relaxed text-slate-400" data-testid="footer-service-area">Ocala office · Contact us to confirm service availability for your city and county.</p>
          </div>
          <div className="min-w-0">
            <h2 className="mb-4 text-base font-bold text-white">Contact Hardwire</h2>
            <a href={BUSINESS.telephone} className="flex items-center gap-2 py-1 hover:text-white" data-testid="footer-call-link"><Phone size={16} />{BUSINESS.phone}</a>
            <a href={`mailto:${BUSINESS.email}`} className="mt-2 flex items-start gap-2 text-sm hover:text-white" data-testid="footer-email-link"><Mail size={16} className="mt-1 shrink-0" /><span className="break-all">{BUSINESS.email}</span></a>
            <button onClick={() => navigate('/login')} className="mt-5 text-left text-sm font-semibold text-[#F7C52B]" data-testid="footer-portal-btn">Customer & Builder Portal Sign In →</button>
          </div>
          <div>
            <h2 className="mb-4 text-base font-bold text-white">Licensing Information</h2>
            <div className="space-y-2 text-sm" data-testid="footer-license-details"><p>License holder: {BUSINESS.licenseHolder}</p><p>Electrical license: {BUSINESS.license}</p><p>County certification: {BUSINESS.countyCertification}</p></div>
            <Link to="/about#licensing" className="mt-4 inline-block text-sm text-[#F7C52B]" data-testid="footer-license-link">Licensing & documentation</Link>
          </div>
        </div>
        <div className="border-t border-slate-800 px-5 py-6">
          <div className="mx-auto flex max-w-[1340px] flex-col justify-between gap-4 text-xs text-slate-400 sm:flex-row">
            <span>© {new Date().getFullYear()} {BUSINESS.name}</span>
            <div className="flex flex-wrap gap-x-5 gap-y-3">
              <Link to="/about" data-testid="footer-about">About</Link><Link to="/terms" data-testid="footer-terms">Terms of Service</Link><Link to="/privacy" data-testid="footer-privacy">Privacy Policy</Link>
              <button onClick={() => window.dispatchEvent(new Event('privacy-preferences'))} data-testid="privacy-settings">Privacy Preferences</button>
            </div>
          </div>
          <div className="mt-7 flex flex-wrap gap-x-6 gap-y-3 text-sm">
            {PUBLIC_NAV.filter(([path]) => ['/services', '/projects', '/resources', '/marketplace'].includes(path)).map(([path, label]) => <Link key={path} to={path} data-testid={`footer-nav-${label.toLowerCase()}`} className="hover:text-[#F7C52B]">{label}</Link>)}
            <Link to="/service-areas" data-testid="footer-nav-service-areas" className="hover:text-[#F7C52B]">Service Areas</Link>
            <Link to="/start-an-electrical-company" data-testid="footer-nav-program" className="hover:text-[#F7C52B]">Start an Electrical Company</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

